import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 27 29"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill=\"#22303E\" d=\"M21 15.384c0 6.623-6.237 11.34-9.13 13.172a2.71 2.71 0 0 1-2.899.022c-2.867-1.769-8.97-6.34-8.97-13.194C0 9.649 4.7 5 10.5 5 16.299 5 21 9.649 21 15.384\"></path><ellipse cx=\"10.5\" cy=\"15.667\" fill=\"currentColor\" rx=\"8.403\" ry=\"8.533\"></ellipse><path fill=\"#E6EAF4\" d=\"M25 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0\"></path><path fill=\"#22303E\" d=\"M25 10a8 8 0 1 0-16 0 8 8 0 0 0 16 0m2 0c0 5.523-4.477 10-10 10S7 15.523 7 10 11.477 0 17 0s10 4.477 10 10\"></path><path fill=\"#22303E\" d=\"M15.75 14v-4a1.25 1.25 0 1 1 2.5 0v4a1.25 1.25 0 1 1-2.5 0M15.75 6.5v-1a1.25 1.25 0 1 1 2.5 0v1a1.25 1.25 0 1 1-2.5 0\"></path>", 5)
  ]))]))
}
export default { render: render }